import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { applicationConstants } from 'src/app/constants';
import { UtilService } from 'src/app/service/util.service';
import * as $ from 'jquery';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.less']
})
export class CustomFooterComponent implements OnInit {

  innerWidth;
  classSize: string="";
  privacyandsecurityLink: string = "";
  legalLink: string = "";
  accessibilityLink: string = "";
  cookiePolicyLink: string = "";
  minusDisabled: boolean = true;
  plusDisabled: boolean = false;
  currentLang:string
  constructor(private utilService: UtilService,
    private translate: TranslateService) {

  }

  ngOnInit(): void {
      
    this.currentLang = sessionStorage.getItem("lang_ref")

    this.utilService.windowWidth.subscribe(val => {
      this.innerWidth = val;
    });

    this.translate.get('footer.newPrivacyURL').subscribe((res: string) => {
      this.privacyandsecurityLink = res || "";
     
     
    });

    this.translate.get('footer.legalLink').subscribe((res: string) => {
      this.legalLink = res || "";
    
     
    });

    this.translate.get('footer.accessibilityLink').subscribe((res: string) => {
      this.accessibilityLink = res || "";
     
    });
    this.translate.get('footer.cookiePolicyLink').subscribe((res: string) => {
      this.cookiePolicyLink = res || "";
     
    });
    this.classSize=document.getElementById("main-id").className;

    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      let lang = e.lang || "en";
      this.currentLang=e.lang;
    });

  }
  isMediumDevice() {
    return this.innerWidth > applicationConstants.mediumDeviceWidth ? true : false;
  }
  increaseFontSize() {
    this.minusDisabled = false;

    const className: string = document.getElementById("main-id").className;
    switch (className) {
      case 'text-size1': document.getElementById("main-id").className = "text-size2";
      document.getElementById("sidebarTitle").className = "ovrflowwrap";

        this.minusDisabled = false;
        this.plusDisabled = false;
        break;
      case 'text-size2': document.getElementById("main-id").className = "text-size3";
        this.minusDisabled = false;
        this.plusDisabled = false;
        break;
      case 'text-size3': document.getElementById("main-id").className = "text-size4";
        this.minusDisabled = false;
        this.plusDisabled = true;
        break;
      default: break;
      
    }
    this.classSize=document.getElementById("main-id").className;
  }
  decreaseFontSize() {
    const className: string = document.getElementById("main-id").className;
    switch (className) {
      case 'text-size4': document.getElementById("main-id").className = "text-size3";
      // document.getElementById("sidebarTitle").className = "ovrflowwrap";
        this.minusDisabled = false;
        this.plusDisabled = false;
        break;
      case 'text-size3': document.getElementById("main-id").className = "text-size2";
        this.minusDisabled = false;
        this.plusDisabled = false;
        break;
      case 'text-size2': document.getElementById("main-id").className = "text-size1";
        this.minusDisabled = true;
        this.plusDisabled = false;
        $("#sidebarTitle").removeClass("ovrflowwrap");
        break;
      default: break;
    }
    this.classSize=document.getElementById("main-id").className;
  }
}